import * as React from 'react';
import { IMobileWaypoint } from '../../../interfaces';
import { WaypointRowHeader } from './WaypointRowHeader';
import { WaypointRowBody } from './WaypointRowBody';

interface Props extends IMobileWaypoint {
    index: number;
    collapsed: boolean;
    isLastRow: boolean;
    title: string;
    isEmbarked: boolean;
    onHeaderClick(index: number): void;
}

export function WaypointRow(props: Props) {
    const {
        index,
        day,
        title,
        isPortOfEmbarkation,
        isPortOfDisembarkation,
        info,
        collapsed,
        onHeaderClick,
        isLastRow,
        isEmbarked,
    } = props;
    const headerProps = {
        index,
        day,
        title,
        isPortOfEmbarkation,
        isPortOfDisembarkation,
        info,
        collapsed,
        isLastRow,
        onClick: onHeaderClick,
        isSeeDay: title === 'at sea',
        isEmbarked,
    };
    return (
        <div>
            <WaypointRowHeader {...headerProps} />
            {!collapsed && <WaypointRowBody {...props} />}
        </div>
    );
}
